import { ITracking } from './tracking.types';

export const dataLayerPush = (data: ITracking): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};
